import { Button } from '@nextui-org/react';
import { useOrder } from '@scripts/frontend/features/shop/order/libs/useOrder';
import { useConfirmationDialog } from '@shared/features/confirm-modal/ConfirmationDialog';
import { __ } from '@wordpress/i18n';
import toast from 'react-hot-toast';

export function CancelOrderButton({ orderId }: { orderId: string }) {
    const { getConfirmation } = useConfirmationDialog();
    const { mutate } = useOrder().getOrderById(orderId);
    const { cancel, isLoading } = useOrder().cancelOrder(orderId);

    async function handleCancelOrder() {
        try {
            const confirmed = await getConfirmation({
                body: (
                    <div>
                        <p>Are you sure you want to cancel this order?</p>
                    </div>
                ),
                confirmButtonProps: {
                    color: 'danger',
                },
                confirmText: 'Cancel',
                dismissButtonProps: {
                    color: 'default',
                },
                dismissText: 'No',
                header: 'Cancel Order Confirmation!',
            });

            if (!confirmed) {
                return;
            }
            await cancel();
            toast.success('Order canceled successfully');
        } catch (error: Error | unknown) {
            if (error instanceof Error) {
                toast.error(error.message);
            } else {
                toast.error(`Failed to cancel order`);
            }
        } finally {
            mutate();
        }
    }
    return (
        <Button color="danger" isLoading={isLoading} onPress={handleCancelOrder} variant="bordered">
            Cancel
        </Button>
    );
}

export default CancelOrderButton;
